import React, { useState } from 'react';
import Clipboard from './Clipboard.svg';
import Check from './Check.svg';
import styles from './ClipboardButton.module.css';
import { useDispatch } from 'react-redux';
import { copyMessage } from '../../redux/message/actions.js';
import { marked } from 'marked';

function ClipboardButton({ user_id, message_id, message_content}) {
  const dispatch = useDispatch();
  const [isCopied, setIsCopied] = useState(false);

  const handleClick = () => {

    const formattedMessageContent = marked(message_content);

    const textToCopy = `
      ${formattedMessageContent}
    `;
    
    navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([textToCopy], { type: 'text/html' }),
        'text/plain': new Blob([textToCopy.replace(/<[^>]+>/g, '')], { type: 'text/plain' }),
      })
    ]).then(() => {
      dispatch(copyMessage(user_id, message_id));
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  return (
    <img 
      className={styles.image}
      src={isCopied ? Check : Clipboard}
      alt={isCopied ? "Check" : "Clipboard"} 
      onClick={handleClick} 
    />
  );
}

export default ClipboardButton;

